import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";

export default createReactClass({
  displayName: "Root",
  propTypes: {
    circleId: PropTypes.number.isRequired,
  },
  getInitialState() {
    return {
      roles: [],
    };
  },
  componentDidMount() {
    this.getCircleRolesListDFromServer();
  },
  getCircleRolesListDFromServer() {
    $.ajax({
      url: "/api/circle/circles_roles",
      type: "GET",
      cache: false,
      data: {
        circle_id: this.props.circleId,
      },
    })
      .done(
        function(data) {
          this.setState({
            roles: data.circlesRoles,
          });
        }.bind(this)
      )
      .fail(function() {}.bind(this));
  },
  render() {
    var rolesView = this.state.roles.map(function(role) {
      return (
        <li
          style={{
            background: `url(${role.image_data})no-repeat center/cover`,
          }}
          data-role-name={role.role}
          data-role-description={role.description}
          key={role.id}
        />
      );
    }, this);

    var intro = this.state.roles.map(function(role) {
      return (
        <div className="intro" key={role.id}>
          <div className="prof">
            <p style={{ backgroundImage: `url(${role.image_data})` }} />
            <div>
              <h2>{role.role}</h2>
              {/* <p><button>この役割でメンバー申請する</button></p> */}
            </div>
          </div>
          <p>{role.description}</p>
        </div>
      );
    }, this);

    return (
      <div className="panel_area block">
        <h2>どんな役割があるの？</h2>
        <ul className="select mt20">{rolesView}</ul>
        {intro}
      </div>
    );
  },
});
